import styled from 'styled-components'

import { IconsQA } from 'shared/dataAttributes'
import { colors } from 'shared/lib'

type MasterCardProps = {
  size?: 'small' | ''
}

export const MasterCard = ({ size = '' }: MasterCardProps) => (
  <Wrapper $size={size}>
    <CustomSvg
      $size={size}
      data-qa={IconsQA.MasterCardIcon}
      fill="none"
      height="10"
      viewBox="0 0 17 10"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="MasterCard">
        <path
          d="M17.0085 4.99448C17.0066 7.07223 15.7559 8.93218 13.867 9.6666C11.9781 10.401 9.84463 9.85682 8.50781 8.29959C10.1284 6.41568 10.1284 3.5838 8.50781 1.69989C9.84339 0.144088 11.9743 -0.400697 13.8623 0.330997C15.7502 1.06269 17.0023 2.91864 17.0085 4.99448Z"
          fill="#F79E1B"
          id="Shape"
        />
        <path
          d="M9.72375 4.99466C9.72259 6.21213 9.28975 7.38732 8.50644 8.29978C6.88587 6.41587 6.88587 3.58398 8.50644 1.70007C9.28743 2.60981 9.7201 3.78083 9.72375 4.99466Z"
          fill="#FF5F00"
          id="Shape_2"
        />
        <path
          d="M7.29017 4.99468C7.29133 6.21214 7.72417 7.38733 8.50748 8.29979C7.1726 9.86327 5.0361 10.4124 3.1435 9.67849C1.2509 8.94457 -0.00195312 7.08107 -0.00195312 4.99994C-0.00195312 2.91881 1.2509 1.05531 3.1435 0.321385C5.0361 -0.412541 7.1726 0.136603 8.50748 1.70009C7.72649 2.60982 7.29382 3.78084 7.29017 4.99468Z"
          fill="#EB001B"
          id="Shape_3"
        />
      </g>
    </CustomSvg>
  </Wrapper>
)

const CustomSvg = styled.svg<{ $size: MasterCardProps['size'] }>`
  background: ${colors.FC2_WHITE};
  height: ${({ $size }) => ($size === 'small' ? '10px' : '15px')};
  width: ${({ $size }) => ($size === 'small' ? '18px' : '27px')};
`
const Wrapper = styled.div<{ $size: MasterCardProps['size'] }>`
  align-items: center;
  background: ${colors.FC2_WHITE};
  border-radius: 2px;
  border: 1px solid ${colors.FC2_LIGHTEST_GREY};
  display: flex;
  height: ${({ $size }) => ($size === 'small' ? '24px' : '27px')};
  justify-content: center;
  width: ${({ $size }) => ($size === 'small' ? '36px' : '40px')};
`
